import script from "./MenuManage.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuManage.vue?vue&type=script&setup=true&lang=js"

import "./MenuManage.vue?vue&type=style&index=0&id=0c371fd1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c371fd1"]])

export default __exports__